{
  "APP_NAME": "SGS",
  "About": "Acerca de",
  "Hello world !": "¡Hola Mundo!",
  "Home": "Inicio",
  "Logged in as": "Conectado como",
  "Login": "Iniciar sesión",
  "Logout": "Salir",
  "Password": "Contraseña",
  "Password is required": "Se requiere contraseña",
  "Username": "Nombre de usuario",
  "Username is required": "Se requiere nombre de usuario",
  "Username or password incorrect.": "Usuario o contraseña incorrectos.",
  "Remember me": "Recuérdame",
  "Version": "Versión"
}
